module.exports = __webpack_public_path__ + "img/2000010404.9ad2b205.png";